import { useRef } from 'react';
import { handleExitFullscreenClick } from '@pm2/react-utils';
import { useNotifier, useModalContentManager } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { Button } from '@ui/kit';
import { RetryButton, ShareButton } from '@utils/component-framework';
import { useFullscreenState, useElementSize, ShowFor } from '@utils/react';
import { useShareWithTeacherAction } from '../state/actions/share.js';
import { footerSize, footer, retryButton, shareButton, mobileCloseButton } from './molecule.footer.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ResultsFooter(props) {
  const ref = useRef(null);
  const notifier = useNotifier();
  const onShareWithTeacher = useShareWithTeacherAction(props.component.entryKey, props.onShareWithTeacher);
  const {
    fullscreenEnabled
  } = useFullscreenState();
  const modal = useModalContentManager();
  useElementSize(ref, {
    applyTo: props.rootRef ?? null,
    axis: "vertical",
    varName: footerSize.propName
  });
  const onMobileClose = () => {
    if (fullscreenEnabled) {
      handleExitFullscreenClick(notifier);
    } else if (!modal.isUnavilable) {
      modal.onDismiss();
    }
  };
  return /*#__PURE__*/jsxs("footer", {
    ref: ref,
    className: footer,
    children: [/*#__PURE__*/jsx(RetryButton, {
      className: retryButton,
      context: "button",
      onReset: props.onResetEntry
    }), /*#__PURE__*/jsx(ShareButton, {
      className: shareButton,
      entryKey: props.component.entryKey,
      onShareWithTeacher: onShareWithTeacher,
      layout: "solid"
    }), (fullscreenEnabled || !modal.isUnavilable) && /*#__PURE__*/jsx(ShowFor, {
      breakpoint: breakpoints.mobile,
      className: mobileCloseButton,
      children: /*#__PURE__*/jsx(Button, {
        theme: "secondary",
        onClick: onMobileClose,
        children: "Luk opgaven"
      })
    })]
  });
}

export { ResultsFooter };
//# sourceMappingURL=molecule.footer.js.map
